<template>
     <div class="no-data">
         <img class="no-data-img" :src="noDataImg" :style="imgStyle"/>
         <p class="title">{{title}}</p>
     </div>
</template>
<script>
    import NoDataImg from '../../../static/img/common/no_data.png'
    export default {
         props:{
            title:{
                type: String,
                default:''
            },
            width:{
                type: String,
                default:'490px'
            },
            height:{
                type:String,
                default:'260px'
            },
            imgStyle:{
                type: Object,
                default: {}
            }
         },
         data: function data() {
             return {
                 noDataImg: NoDataImg
             }
         }
    }
</script>
<style lang="scss" scoped>
    .no-data{
        text-align: center;
        padding-bottom: 40px;
        width: 100%;
        .title{
            margin-top: 20px;
            font-size: 16px;
            color: #999;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/common/noData/noData.vue